import React from 'react';
import { useForm, ValidationError } from '@formspree/react';
import './Modal.css';

const Modal = ({ show, onClose }) => {
  // Подключаем Formspree, передавая ТОЛЬКО ID формы
  const [state, handleSubmit] = useForm("xanjevaa"); // <-- ИСПРАВЛЕНО

  if (!show) {
    return null;
  }

  // Если форма успешно отправлена, показываем сообщение
  if (state.succeeded) {
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={e => e.stopPropagation()}>
          <button className="close-button" onClick={onClose}>×</button>
          <div className="success-message">
            <h3>Thanks for joining!</h3>
            <p>You'll be the first to know about KikoAI updates.</p>
          </div>
        </div>
      </div>
    );
  }

  // Отображаем саму форму
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>×</button>
        <h3>Join the Waitlist</h3>
        <p>Be the first to know when KikoAI launches.</p>
        <form onSubmit={handleSubmit} className="modal-form">
          <input
            id="email"
            type="email"
            name="email"
            placeholder="Enter your email"
            required
          />
          <ValidationError 
            prefix="Email" 
            field="email"
            errors={state.errors}
            className="validation-error"
          />
          <button type="submit" disabled={state.submitting}>
            {state.submitting ? 'Submitting...' : 'Sign Up'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Modal;
